import { Checkbox as BaseCheckbox } from './Checkbox'
import { Group } from './Group'

export type { CheckboxProps, CheckboxOptionType, CheckboxRef } from './Checkbox'

// should we do it with hoist-non-react-statics ?
export const Checkbox = Object.assign(BaseCheckbox, {
  Group
})
